export const allowedMime = [
  "application/pdf",
  "application/vnd.oasis.opendocument.text",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.oasis.opendocument.spreadsheet",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "image/jpeg",
  "image/png",
  "text/html",
] as const;

export const displayableMime = ["application/pdf", "image/jpeg", "image/png"];

export type TAllowedMime = (typeof allowedMime)[number];

export const isValidMimeType = (mimeType: string): mimeType is (typeof allowedMime)[number] => {
  return allowedMime.includes(mimeType as (typeof allowedMime)[number]);
};

export const displayOrDownloadDocument = (
  document: { mimeType: string; name: string },
  downloadDocument,
  behaviour: "download" | "display"
) => {
  const link = window.document.createElement("a");
  if (window.URL?.createObjectURL) {
    link.href = window.URL.createObjectURL(
      new Blob([downloadDocument?.data], {
        type: document.mimeType,
      })
    );
    switch (behaviour) {
      case "download":
        link.download = document.name.replace(/_([^_]*)$/, ".$1");
        window.document.body.appendChild(link);
        break;
      case "display":
        link.target = "_blank";
        break;
    }

    link.click();
    setTimeout(() => {
      window.URL.revokeObjectURL(link.href);
    }, 120000);
  }
};

export const displayOrDownloadUrlDocument = async (
  url: string,
  behaviour: "download" | "display",
  name: string,
  type: string
) => {
  const documentFetch = await fetch(url);
  const blob = await documentFetch.blob();
  const obj = URL.createObjectURL(new Blob([blob], { type }));
  if (behaviour === "display") {
    window.open(obj, name, "noopener=true,noreferrer=true");
  } else {
    const link = window.document.createElement("a");
    link.href = obj;
    link.download = name;
    window.document.body.appendChild(link);
    link.dispatchEvent(
      new MouseEvent("click", {
        bubbles: true,
        cancelable: true,
        view: window,
      })
    );
    window.document.body.removeChild(link);
  }
  setTimeout(() => {
    URL.revokeObjectURL(obj);
  }, 120000);
};

export const getBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.readAsDataURL(file);

    reader.onload = () => {
      const result = reader.result;
      if (result && typeof result === "string") {
        const base64 = result.split(",")[1];
        resolve(base64);
      }
      reject();
    };
  });
};

export const dataUriToBlob = (dataURI: string) => {
  const B = atob(dataURI.split(",")[1]);
  const L = B.length;
  const A: number[] = [];

  const Mime = dataURI.split(",")[0].split(":")[1].split(";")[0];

  for (let i = 0; i < L; i++) {
    A.push(B.charCodeAt(i));
  }

  return new Blob([new Uint8Array(A)], { type: Mime });
};

export const displayUrlDocumentWithoutDownload = (uri: string, name: string) => {
  const obj = URL.createObjectURL(dataUriToBlob(uri));
  window.open(obj, name, "noopener=true,noreferrer=true");
  setTimeout(() => {
    URL.revokeObjectURL(obj);
  }, 2000);
};
